import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import CaretDown from "Images/profile/CaretDown.svg";
import CloseImg from "Images/profile/close_icon.svg";
import utils from "Profile/utils";
import useMultipleOutsideClick from "Root/hooks/useMultipleOutsideClick";
import useOutsideClick from "Root/hooks/useOutsideClick";
import flavorOptionStyle from "./SubscriptionFlavorOption/style.module.css";
import FlavorOption from "./SubscriptionFlavorOption";
import { getLabel } from "../FormSelect";
import styles from "../../SubscriptionPageV2/OrderItemCard/style.module.css";
export const NO_FLAVORS_KEY = "noFlavors";
/*
 * Flavors Select for Subscription Component
 */
const SubscriptionFlavorsSelect = ({ bagId, className, selected, name, options, label, noFlavors, maxFlavors, toggleNutritionFacts, isOpenedView, isOpenedSelect, setIsOpenedSelect, headerTitle, productQuanity, originalNoFlavorsFlag, onChange, isProtein = false, multipleClick = false, addBtnRef, onAddItem, getBtnRef, getItNow, }) => {
    const selectWrapper = useRef(null);
    const totalSelected = selected?.reduce((prev, curr) => prev + curr.count, 0);
    const getMaxedOut = totalSelected >= maxFlavors;
    // const reorderFlavors = () => {
    //   if (typeof flavorsObj !== "undefined") {
    //     options.sort((a, b) => {
    //       return flavorsObj[b.short_name] - flavorsObj[a.short_name];
    //     });
    //   }
    // };
    // useEffect(() => {
    //   reorderFlavors();
    // }, [options]);
    const [isOpen, setIsOpen] = useState(false);
    const [isNoFlavorsActive, setIsFlavorsButtonActive] = useState(originalNoFlavorsFlag);
    const onSelectNoFlavors = () => {
        onChange(0, NO_FLAVORS_KEY, bagId);
        setIsFlavorsButtonActive(true);
    };
    const onSelect = (value, flavorName) => {
        onChange(value, flavorName, bagId, isProtein);
        setIsFlavorsButtonActive(false);
    };
    useEffect(() => {
        if (isOpenedSelect) {
            setIsOpen(true);
            //   } else {
            //     setIsOpenedSelect && setIsOpenedSelect(false);
        }
    }, [isOpenedSelect]);
    const hook = multipleClick ? useMultipleOutsideClick : useOutsideClick;
    const params = multipleClick
        ? [
            [selectWrapper, addBtnRef, getBtnRef],
            [
                () => {
                    setIsOpenedSelect && setIsOpenedSelect(false);
                    setIsOpen(false);
                },
                () => {
                    onAddItem();
                },
                () => {
                    getItNow();
                },
            ],
        ]
        : [
            selectWrapper,
            () => {
                setIsOpenedSelect && setIsOpenedSelect(false);
                setIsOpen(false);
            },
        ];
    hook(...params);
    // useOutsideClick(selectWrapper, () => {
    //   setIsOpenedSelect && setIsOpenedSelect(false);
    //   setIsOpen(false);
    // });
    // useMultipleOutsideClick(
    //   [selectWrapper, addBtnRef],
    //   [
    //     () => {
    //       setIsOpenedSelect && setIsOpenedSelect(false);
    //       setIsOpen(false);
    //     },
    //     () => {
    //       onAddItem();
    //     },
    //   ]
    // );
    const getSelectedSpan = () => {
        const labelString = utils.getSelectedFlavorString(selected, options);
        const splitedLabel = getLabel(labelString);
        if (splitedLabel.subLabel) {
            return (_jsxs("span", { children: [splitedLabel.label, splitedLabel.subLabel && _jsx("span", { className: "gray-text", children: splitedLabel.subLabel })] }));
        }
        return splitedLabel.label;
    };
    const getHeaderTitle = () => {
        if (productQuanity === 0) {
            switch (name) {
                case "hydration":
                    return "Please select 1 or 2 bags to choose your flavor.";
                case "preworkout":
                    return "Please select 1 or 2 bags to choose your flavor.";
                case "protein":
                    return `Please select 1 or 2 bags to choose flavor boosts.`;
                default:
                    return "";
            }
        }
        else if (totalSelected < maxFlavors) {
            switch (name) {
                case "hydration":
                    return "Please choose a Hydration flavor.";
                case "preworkout":
                    return "Please choose a Pre-Workout flavor.";
                case "protein":
                    return `Enjoy ${maxFlavors} flavors at no additional cost.`;
                default:
                    return "";
            }
        }
        else {
            if (maxFlavors > 1) {
                return "Flavors selected successfully.";
            }
            return "Flavor selected successfully.";
        }
    };
    const getFlavorAmount = (option) => selected.find((item) => item.short_name === option.short_name)?.count || 0;
    return (_jsxs("div", { ref: selectWrapper, className: `form-select ${className || ""}`, children: [label && _jsx("span", { className: "my-profile__input-label", children: label }), _jsxs("div", { className: "form-select__wrapper", children: [!isOpenedView && (_jsxs("button", { type: "button", className: `form-select__option form-select__option-selected ${isOpen ? "form-select__option-opened" : ""}`, onClick: () => setIsOpen(!isOpen), children: [_jsx("div", { className: "form-select__option-wrapper", children: _jsx("span", { className: "form-select__option-label flavor-select__option-label-wrapper", children: isOpen ? (_jsxs("div", { className: styles.flavors_select_header, children: [_jsx("span", { className: styles.flavors_select_header__title, children: headerTitle }), _jsx("span", { children: getHeaderTitle() }), toggleNutritionFacts && (_jsx("span", { className: "underlined-form-button underlined-form-button-span", role: "button", onClick: toggleNutritionFacts, onKeyUp: toggleNutritionFacts, tabIndex: 0, children: "Nutrition Facts" }))] })) : (getSelectedSpan()) }) }), _jsx("img", { className: `form-select__option-open-icon ${isOpen ? "form-select__option-open-icon-opened" : ""}`, src: CaretDown, alt: "" })] })), (isOpen || isOpenedView) && (_jsxs("div", { className: "form-select__options form-flavors-select__options", children: [options.map((option) => (_jsx(FlavorOption, { maxedOut: getMaxedOut, selectedOptions: selected, onChange: onSelect, flavorAmount: getFlavorAmount(option), isProtein: isProtein, out_of_stock: option.out_of_stock, ...option }, option.full_name))), noFlavors && name === "protein" && (_jsxs("button", { onClick: onSelectNoFlavors, type: "button", className: `${flavorOptionStyle.no_flavors}${isNoFlavorsActive ? ` ${flavorOptionStyle.no_flavors_active}` : ""}`, children: [_jsx("img", { src: CloseImg, alt: "" }), _jsx("span", { children: "No Flavors" })] }))] }))] })] }));
};
export default SubscriptionFlavorsSelect;
